<template>
  <section class="shield-home s-bios">
    <ShieldHeader />

    <div class="container-wide">
      <div class="content">
        <ShieldNavigation />

        <div class="banner">
           <picture>
            <source
              media="(max-width: 480px)"
              srcset="../assets/shield-banners/shield-bios-banner-01-square.jpg"
              alt=""
            />
            <source
              media="(min-width:481px)"
              srcset="../assets/shield-banners/shield-bios-banner-01.jpg"
              alt=""
            />
            <img
              src="../assets/shield-banners/shield-bios-banner-01.jpg"
              alt=""
            />
          </picture>
        </div>

        <div class="copy">
          <figure class="bio-picture fl-left">
            <img
              src="@/assets/people/JacobPritchard.jpg"
              alt="Jacob W. Pritchard - Shield Maintenance"
              width="216"
              height="307"
            />
          </figure>

          <h2>Jacob W. Pritchard - Managing Partner</h2>
          <p>
            With over 15 years plumbing and commercial electrical installation
            experience, Jacob is well suited to be the Managing Partner of
            Shield Maintenance. Now that he is managing Shield Maintenance, he
            brings to bear his experience as a building supervisor responsible
            for building maintenance of high-rise offices and multi-use
            buildings in downtown Fort Worth.
          </p>

          <p>
            That experience taught him to make sure the repairs are made
            correctly and in a timely manner. By working in that environment he
            also learned to be aware of the expectations and needs of the owners
            and clients. Jacob knows they depend upon him to fix equipment and
            make the repairs necessary so everyone in the building, including
            tenants, are made whole as quickly as possible. He understands how
            important it is to keep everyone in the communication loop so they
            are aware of the process and when the situation will be remedied.
            Jacob is dedicated to prompt delivery of repair services and
            maintenance that protects the owners and clients he serves and keeps
            the buildings under his care functioning and operating at full
            efficiency.
          </p>

          <p>
            You can count on Jacob because he says that when he is not working,
            he just thinks about maintenance!
          </p>

          <hr class="medium-divider" />

          <figure class="bio-picture fl-left">
            <img
              src="@/assets/people/Jeff-Oshields.jpg"
              alt="Jeff O'Shields - Shield Maintenance"
              width="216"
              height="307"
            />
          </figure>

          <h2>Jeff O'Shields - Project Manager</h2>
          <p>
            Jeff is Shield Maintenance’s creative troubleshooter and problem
            solver. He has over a decade of commercial building maintenance for
            the Dallas and Arlington ISDs. From the foundations of the buildings
            he maintained to the top of their roofs, and everything in between,
            Jeff has seen it all and repaired and rebuilt all types of equipment
            and fixed all types of problems that have and do arise.
          </p>

          <p>
            Jeff has special skills that complement his building maintenance
            experience that include welding, metal working, building furniture,
            and making the occasional local craft beer disappear.
          </p>

          <p>
            His true loves are his wife of 19 years and their young son, and
            spending time enjoying outdoor activities.
          </p>
        </div>
      </div>
    </div>

    <ShieldFooter />
  </section>
</template>

<script>
import ShieldHeader from "@/components/ShieldHeader.vue";
import ShieldNavigation from "@/components/ShieldNavigation.vue";
import ShieldFooter from "@/components/ShieldFooter.vue";

export default {
  name: "ShieldHome",
  components: {
    ShieldHeader,
    ShieldNavigation,
    ShieldFooter
  }
};
</script>

<style lang="scss" scoped>
.content {
  background: #fff;
  min-height: 50vh;
}

.section-link {
  text-decoration: none;
}

.section-link:link,
.section-link:visited {
  color: #444;
}
</style>
